import { render, staticRenderFns } from "./ClustersTabs.vue?vue&type=template&id=812ee26e&"
import script from "./ClustersTabs.vue?vue&type=script&lang=ts&"
export * from "./ClustersTabs.vue?vue&type=script&lang=ts&"
import style0 from "./ClustersTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports